import CartSection from '../components/CartSection';

export default function CartPage() {
  return (
    <>
      <CartSection />
    </>
  );
}
